import {
	JSON_FORM,
	UPDATE_LAST_ANSWERED_QUESTIONS,
} from '#app/constants/forms.ts'
import { type State, type Action } from '#types/form/wizard.ts'

export function handleUpdateLastAnsweredQuestions<T>(
	state: State<T>,
	action: Action<T>,
): State<T> {
	if (
		state.type !== JSON_FORM ||
		action.type !== UPDATE_LAST_ANSWERED_QUESTIONS
	) {
		return state
	}

	const { currentQuestionTreeId, currentQuestionId } = action
	let newStack = [...state.answeredQuestionsStack]

	const existingItemIndex = newStack.findIndex(
		item => item.id === currentQuestionTreeId,
	)

	if (existingItemIndex !== -1) {
		newStack[existingItemIndex] = {
			...newStack[existingItemIndex],
			answers: [...newStack[existingItemIndex].answers, currentQuestionId],
			currentQuestionId: currentQuestionId,
		}
	} else {
		newStack.push({
			id: currentQuestionTreeId,
			answers: [currentQuestionId],
			currentQuestionId: currentQuestionId,
		})
	}

	return {
		...state,
		answeredQuestionsStack: newStack,
	}
}
